export const APP_CODE = 'SUBSCRIPTION';

export const INSUFFICIENT_PERMISSION_MESSAGE =
  'You do not have sufficient permissions to access this feature. Contact your administrator if you need access.';

export const RESOURCES = {
  organizations: {
    segment: 'organizations',
    title: 'Organization',
    read: 'READ_SUBSCRIPTION_ORGANIZATION',
    create: 'CREATE_SUBSCRIPTION_ORGANIZATION',
    update: 'UPDATE_SUBSCRIPTION_ORGANIZATION',
  },
  partners: {
    segment: 'partners',
    title: 'Partners',
    read: 'READ_SUBSCRIPTION_PARTNER',
    create: 'CREATE_SUBSCRIPTION_PARTNER',
    update: 'UPDATE_SUBSCRIPTION_PARTNER',
  },
  products: {
    segment: 'products',
    title: 'Products',
    read: 'READ_SUBSCRIPTION_PRODUCT',
    create: 'CREATE_SUBSCRIPTION_PRODUCT',
    update: 'UPDATE_SUBSCRIPTION_PRODUCT',
  },
  meters: {
    segment: 'meters',
    title: 'Meters',
    read: 'READ_SUBSCRIPTION_PRODUCT',
    create: 'CREATE_SUBSCRIPTION_PRODUCT',
    update: 'UPDATE_SUBSCRIPTION_PRODUCT',
  },
  subscriptions: {
    segment: 'subscriptions',
    title: 'Subscriptions',
    read: 'READ_SUBSCRIPTION',
    create: 'CREATE_SUBSCRIPTION',
    update: 'UPDATE_SUBSCRIPTION',
  },
};

export const RESOURCE_KEYS = Object.keys(RESOURCES);

// Short-form permission codes that map to canonical SUBSCRIPTION permission codes.
export const PERMISSION_ALIASES = {
  READ_PRODUCT: 'READ_SUBSCRIPTION_PRODUCT',
  CREATE_PRODUCT: 'CREATE_SUBSCRIPTION_PRODUCT',
  UPDATE_PRODUCT: 'UPDATE_SUBSCRIPTION_PRODUCT',
  ARCHIVE_PRODUCT: 'ARCHIVE_SUBSCRIPTION_PRODUCT',
  READ_ORGANIZATION: 'READ_SUBSCRIPTION_ORGANIZATION',
  CREATE_ORGANIZATION: 'CREATE_SUBSCRIPTION_ORGANIZATION',
  UPDATE_ORGANIZATION: 'UPDATE_SUBSCRIPTION_ORGANIZATION',
  ARCHIVE_ORGANIZATION: 'ARCHIVE_SUBSCRIPTION_ORGANIZATION',
  READ_PARTNER: 'READ_SUBSCRIPTION_PARTNER',
  CREATE_PARTNER: 'CREATE_SUBSCRIPTION_PARTNER',
  UPDATE_PARTNER: 'UPDATE_SUBSCRIPTION_PARTNER',
  ARCHIVE_PARTNER: 'ARCHIVE_SUBSCRIPTION_PARTNER',
};

export function normalizeSubscriptionPermissions(permissions = []) {
  const normalized = new Set(permissions);

  permissions.forEach((code) => {
    const canonical = PERMISSION_ALIASES[code];

    if (canonical) {
      normalized.add(canonical);
    }
  });

  return [...normalized];
}

export function hasSubscriptionPermission(permissions, code) {
  return normalizeSubscriptionPermissions(permissions).includes(code);
}

export function getResourceConfig(resourceKey) {
  return RESOURCES[resourceKey];
}

export function getFirstReadableResourcePath(subscriptionPermissions = []) {
  const readable = RESOURCE_KEYS.find((key) => hasSubscriptionPermission(subscriptionPermissions, RESOURCES[key].read));

  if (readable) {
    return `/${RESOURCES[readable].segment}`;
  }

  return '/organizations';
}
